/* eslint-disable */
import { useEffect, useRef } from "react";
import { notification, Button } from "antd";
import { ReloadOutlined } from "@ant-design/icons";

/**
 * AppVersionGate — deteta novos builds e recarrega sem o utilizador limpar cache.
 *
 * Compara o BUILD_ID embutido no bundle (REACT_APP_BUILD_ID) com o /meta.json
 * servido sempre sem cache. Quando difere, mostra um aviso com "Atualizar" e,
 * se a página estiver oculta/ao voltar ao foco, recarrega automaticamente.
 */
const CURRENT = process.env.REACT_APP_BUILD_ID || "dev";
const POLL_MS = 2 * 60 * 1000; // 2 minutos

export default function AppVersionGate() {
  const notified = useRef(false);

  useEffect(() => {
    let stopped = false;

    const reload = () => {
      // força ir buscar index.html + chunks novos
      window.location.reload();
    };

    const check = async () => {
      try {
        const res = await fetch(`/meta.json?ts=${Date.now()}`, {
          cache: "no-store",
          headers: { "Cache-Control": "no-cache" },
        });
        if (!res.ok) return;
        const data = await res.json();
        const latest = data && data.buildId;
        if (!latest || latest === CURRENT || CURRENT === "dev") return;

        if (!notified.current) {
          notified.current = true;
          notification.info({
            key: "app-update",
            message: "Nova versão disponível",
            description: "Há uma atualização da aplicação. Atualize para ver as novidades.",
            duration: 0,
            placement: "bottomRight",
            btn: (
              <Button type="primary" size="small" icon={<ReloadOutlined />} onClick={reload}>
                Atualizar agora
              </Button>
            ),
          });
        }
        // se o separador estiver oculto, recarrega em silêncio quando voltar
        if (document.visibilityState === "hidden") {
          const onVisible = () => {
            document.removeEventListener("visibilitychange", onVisible);
            reload();
          };
          document.addEventListener("visibilitychange", onVisible);
        }
      } catch (_e) {
        /* offline / erro de rede — ignora */
      }
    };

    const onFocus = () => { if (!stopped) check(); };

    check();
    const id = setInterval(check, POLL_MS);
    window.addEventListener("focus", onFocus);

    return () => {
      stopped = true;
      clearInterval(id);
      window.removeEventListener("focus", onFocus);
    };
  }, []);

  return null;
}
